// Extra data-testids for phase-2 modules
export const WF = {
  clientsList: "clients-list",
  clientCreateBtn: "client-create-btn",
  clientSaveBtn: "client-save-btn",
  projectsList: "projects-list",
  projectCreateBtn: "project-create-btn",
  projectSaveBtn: "project-save-btn",
  allocationsList: "allocations-list",
  allocationCreateBtn: "allocation-create-btn",
  allocationSaveBtn: "allocation-save-btn",
  benchList: "bench-list",
  ratesList: "rates-list",
  rateCreateBtn: "rate-create-btn",
};

export const TS = {
  weekGrid: "timesheet-week-grid",
  saveEntryBtn: (proj, day) => `ts-save-${proj}-${day}`,
  submitWeekBtn: "timesheet-submit-week-btn",
  approvalsList: "timesheet-approvals-list",
  approveBtn: (id) => `ts-approve-${id}`,
  rejectBtn: (id) => `ts-reject-${id}`,
  complianceTable: "compliance-table",
};

export const PAY = {
  runsList: "payroll-runs-list",
  createRunBtn: "payroll-create-run-btn",
  runDetail: "payroll-run-detail",
  finalizeBtn: (id) => `payroll-finalize-${id}`,
  payslipsMineList: "payslips-mine-list",
  structureForm: "salary-structure-form",
  structureSaveBtn: "salary-structure-save-btn",
  statutoryTable: "statutory-table",
};

export const BILL = {
  summary: "billing-summary",
  runBtn: "billing-run-btn",
  exportBtn: "billing-export-btn",
};

export const REC = {
  jobsList: "jobs-list",
  jobCreateBtn: "job-create-btn",
  jobSaveBtn: "job-save-btn",
  candidatesList: "candidates-list",
  candidateCreateBtn: "candidate-create-btn",
  candidateSaveBtn: "candidate-save-btn",
};

export const PERF = {
  cyclesList: "cycles-list",
  cycleCreateBtn: "cycle-create-btn",
  goalsList: "goals-list",
  goalCreateBtn: "goal-create-btn",
};
